<template>
  <div
    class="movie-header" :class="{'mobile-layout': showMobileLayout}"
  >
    <div class="movie-bg-container">
      <div class="movie-bg"  
        v-bind:style="calculateBackground"
      ></div>
    </div>
    <div class="container-fluid movie-header__container">

      <div class="movie-header__content" v-if="asset">
        <v-img
          v-if="asset.title_logo"
          height="100%"
          :src="asset.title_logo"
          class="movie-header__image"
        />
        <h2 v-else class="movie-header__title">{{ asset.title }}</h2>

        <p class="movie-header__description" v-if="!showMobileLayout">
          {{ asset.description }}
        </p>
        
        <p class="metadata">
          {{ metadata }}
          <br/>
          <span v-if="!showMobileLayout">
            {{ $t("detail_page.cast") }} {{ actors }}
          </span>
        </p>

        <v-btn
            v-if="!showMobileLayout"
            class="btn-more-details"
            size="small"
            variant="plain"
            @click="toggleMoreDetails"
          >
            {{ $t("detail_page.more_details") }}
        </v-btn>

        <div class="buttons">
          <router-link :to="url">
            <v-btn
              class="button button--mid play"
              color="primary"
            >
              <icon-play-fill />
              {{ $t("detail_page.play") }}
            </v-btn>
          </router-link>
          
          <v-btn class="button button--mid" variant="outlined" color="info" @click="playTrailer">
            {{ $t("detail_page.trailer") }}
          </v-btn>
        
        </div>
      </div>
    </div>

    <movie-description-dialog 
      :assetData="asset" 
      :useLegacyAsset="true"
      @toggleDisplayDialog="toggleMoreDetails"
      :displayDialog="showMoreDetailsDialog" />

    <br class="clear" />
  </div>
  <upgrade-plan-dialog
    v-model="showUpgradePlanDialog"
    :is-mobile="showMobileLayout"
    :displayedFrom="'Played Button'"
  ></upgrade-plan-dialog>
</template>

<script>
import IconPlayFill from "@/components/icons/iconPlayFill.vue";
import IconInfo from "@/components/icons/iconInfo.vue";
import UpgradePlanDialog from "@/components/plans/UpgradePlanDialog.vue";
import MovieDescriptionDialog from "@/components/movies/MovieDescriptionDialog.vue";
import { mapState } from "pinia";
import { UIStore } from "@/stores/uiStore";

export default {
  name: "MovieHeader",
  components: {
    UpgradePlanDialog,
    IconInfo,
    IconPlayFill,
    MovieDescriptionDialog,
  },
  emits: [
    "playTrailer"
  ],
  props: {
    asset: {
      type: Object,
      default: null,
    }
  },
  methods: {
    toggleUpgradePlanDialog() {
      this.clevertap.event.push("Up Convert Banner Displayed", {
        Platform: "Web",
        "Displayed From": "Played Button",
      });
      this.showUpgradePlanDialog = !this.showUpgradePlanDialog;
    },
    toggleMoreDetails(){
      this.showMoreDetailsDialog = !this.showMoreDetailsDialog;
    },
    playTrailer(){
      this.$emit("playTrailer");
    },
  },
  data() {
    return {
      showUpgradePlanDialog: false,
      showMoreDetailsDialog: false
    };
  },
  computed: {
    ...mapState(UIStore, ["showMobileLayout"]),
    url() {
      return this.$t("routes.get_the_full_experience");
    },
    actors() {
      return this.asset.actors
        .map((actor) => actor.name)
        .join(", ");
    },
    calculateBackground() {
      let trailing = this.supportsWebP ? ".webp" : "";
      let bg = this.showMobileLayout
        ? this.asset.mobile + trailing
        : this.asset.desktop + trailing;
      return {
        background: "url('" + bg + "') no-repeat top center",
        backgroundSize: "cover",
      };
    },
    metadata() {
      let m = [];
      if (this.asset.year !== null) {
        m.push(this.asset.year);
      }
      if (this.asset.length !== null) {
        m.push(this.asset.length);
      }
      m.push(this.asset.genres.join(", "));
      // 2019 ‧ 2h 2m ‧ Thriller/Crime
      return m.join(" ‧ ");
    },
  },
};
</script>

<style lang="scss">

.movie-header {
  position: relative;
  padding: 25% 1em;
  overflow: hidden;
  margin: 0;
  height: 0;

  .btn-more-details{
    text-decoration: underline;
    color: white;
    height: 2em !important;
    padding: 0;
    display: block;
    margin-top: 1em;
    font-weight: 400;
  }

  .movie-bg-container{
    &::after{
      content: "";
      background: linear-gradient(90deg, rgba(14,18,27,1) 0%, rgba(14,18,27,1) 80%, rgba(14,18,27,0.95) 85%, rgba(14,18,27,0) 100%);
      height: 100%;
      width: 40%;
      position: absolute;
      display: block;
    }
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    .movie-bg{
      width: 70%;
      position: absolute;
      right: 0;
      height: 100%;
      -webkit-mask-image: linear-gradient(to top, transparent, 10%,  #0c111b);
      mask-image: linear-gradient(to top, transparent, 10%,  #0c111b);
    }
  }


  .movie-header__container{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .movie-header__content {
    z-index: 2;
    position: relative;
    color: white;
    width: 35%;
    box-sizing: content-box;
    min-height: 10em;

    .metadata {
      font-size: 1em;
      color: #ffffff;
      opacity: 0.8;
    }

    .movie-header__title {
      font-size: 2.3em;
      font-weight: 700;
      height: 2em;
      margin: 1em 0;
    }

    .movie-header__image{
      margin: 1em 0;
    }

    .movie-header__description {
      font-size: 1.2em;

      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 6em;
    }

    .buttons {
      margin-top: 1.5em;
      display: flex;
      flex-direction: row;
      button {
        margin: 0 0.5em;
      }
      .button {
        margin-right: 1em;
        text-transform: capitalize;
        font-weight: 400;

        &.play {
          padding: 0.5em 4em;
        }

        .icon {
          width: 1.5em;
          height: 1.5em;

          * {
            fill: white !important;
          }
        }
      }
      :first-child{
        margin-left: 0px;
      }
    }
  }





  @media (min-width: 1920px) {

    .movie-header__content {
      font-size: 0.85vw;
      
      .buttons {
        button{
          padding: 0.8vw;
          font-size: 0.7vw;
        }
      }
    }
    .movie-header__container{
      padding: 3vw 1vw;
    }

  }
}

.movie-header{
  &.mobile-layout{
    .movie-bg-container{
      &::after{
        display: none;
      }
      .movie-bg{
        width: 100%;
        -webkit-mask-image: linear-gradient(to top, transparent, 30%,  #0c111b);
        mask-image: linear-gradient(to top, transparent, 30%,  #0c111b);
      }
    }
  }
}

@media (max-width: 1080px) {

  .movie-header {
    height: auto;
    padding: 1em;
    .movie-header__container{
      position: relative;
      top: 0px;
      transform: translate(0, 0);
      .movie-header__content {
        padding: 350px 0 2em 1em;
        width: 100%;
        .metadata {
          font-size: 0.8em;
        }
      }
    }
    
  }

  
}
</style>
